import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationService } from '../../../services/navigation.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FormConstants } from 'app/constants/form.constants';

@Component({
  selector: 'app-usan-forms',
  templateUrl: './usan-forms.component.html',
  styleUrls: ['./usan-forms.component.scss']
})
export class UsanFormsComponent implements OnInit, OnDestroy {
  formType!: string;
  formTab = 'application-form';

  private usanTabSubscription: Subscription;
  private sizeChangeSubscription!: Subscription;
  private mobileDeviceSize: boolean = false;

  constructor(private route: ActivatedRoute, protected navigationService: NavigationService, private responsive: BreakpointObserver) {
    this.usanTabSubscription = this.navigationService.getUsanFormTabUpdate().subscribe(
      changedTab => {
        this.formTab = changedTab.value;
      });
  }

  ngOnInit(): void {
    let type = this.route.snapshot.paramMap.get('formType');
    let mappedFormType = FormConstants.FORM_TYPE_TRANSLATION_MAP.get(type ? type : '');
    this.formType = type ? type : '';
    this.navigationService.sendUsanFormTabUpdate(this.formTab, false);
    this.navigationService.sendUsanFormTypeUpdate(mappedFormType ? mappedFormType : '');
    this.navigationService.sendSideNavOpenedUpdate(false);
    
    this.sizeChangeSubscription = this.responsive.observe([Breakpoints.Handset]).subscribe(result => {
      if(result.matches) {
        this.mobileDeviceSize = true;
      } else {
        this.mobileDeviceSize = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.usanTabSubscription.unsubscribe();
    this.sizeChangeSubscription.unsubscribe();
  }

  get isMobileDeviceSize(): boolean {
    return this.mobileDeviceSize;
  }
}
